/* ============================================================
   MUD THEORY - theme.js (vanilla, no dependencies)
   ============================================================ */
(function(){
  "use strict";
  var T = window.MudTheory || {};
  // Safety net: if the inline config ever fails to render, keep the drawer working with standard routes.
  T.routes = T.routes || {};
  T.routes.cart_add = T.routes.cart_add || "/cart/add";
  T.routes.cart_change = T.routes.cart_change || "/cart/change";
  T.routes.cart = T.routes.cart || "/cart";
  if(T.cart_type !== "page") T.cart_type = "drawer";
  if(typeof T.free_bar === "undefined") T.free_bar = true;
  if(typeof T.free_threshold !== "number") T.free_threshold = 7500;
  T.money_format = T.money_format || "${{amount}}";
  var $ = function(s, c){ return (c||document).querySelector(s); };
  var $$ = function(s, c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); };

  /* ---------- Money ---------- */
  function formatMoney(cents){
    var value = (cents/100);
    var fmt = T.money_format || "${{amount}}";
    function withComma(n){ return n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","); }
    function withCommaNoDecimal(n){ return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function(_, name){
      switch(name){
        case "amount": return withComma(value);
        case "amount_no_decimals": return withCommaNoDecimal(value);
        case "amount_with_comma_separator": return value.toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        case "amount_no_decimals_with_comma_separator": return withCommaNoDecimal(value);
        default: return withComma(value);
      }
    });
  }
  window.MTformatMoney = formatMoney;

  /* ---------- Reveal animations ---------- */
  function initReveal(){
    if(!document.body.classList.contains("anim-on")) return;
    var els = $$(".reveal:not(.in), .stagger:not(.in)");
    if(!("IntersectionObserver" in window) || !els.length){ els.forEach(function(e){ e.classList.add("in"); }); return; }
    // Anything within the first screen and a half is shown immediately (ad landers: no waiting for a scroll).
    var vh = window.innerHeight || 800, pending = [];
    els.forEach(function(e){
      var top = e.getBoundingClientRect().top;
      if(top < vh * 1.5){ e.classList.add("in"); } else { pending.push(e); }
    });
    if(!pending.length) return;
    var io = new IntersectionObserver(function(ents){
      ents.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add("in"); io.unobserve(e.target); } });
    }, { threshold:.12, rootMargin:"0px 0px -7% 0px" });
    pending.forEach(function(e){ io.observe(e); });
    // safety net: never leave content invisible for long
    setTimeout(function(){ pending.forEach(function(e){ if(e.getBoundingClientRect().top < vh * 1.5) e.classList.add("in"); }); }, 1500);
  }

  /* ---------- Step comparison: tap-to-compare tabs on mobile ---------- */
  function initCompareTabs(){
    $$("[data-compare-grid] .compare-card").forEach(function(card){
      if(card.dataset.tabbed) return; card.dataset.tabbed = "1";
      var cols = card.querySelector(".compare-card__cols"); if(!cols) return;
      var usual = card.querySelector(".compare-col--usual"), ritual = card.querySelector(".compare-col--ritual");
      if(!usual || !ritual) return;
      var tabs = document.createElement("div"); tabs.className = "compare-tabs"; tabs.setAttribute("role", "tablist");
      var bu = document.createElement("button"); bu.type = "button"; bu.className = "compare-tab"; bu.setAttribute("role", "tab");
      var br = document.createElement("button"); br.type = "button"; br.className = "compare-tab"; br.setAttribute("role", "tab");
      var ut = usual.querySelector(".compare-col__tag"), rt = ritual.querySelector(".compare-col__tag");
      bu.textContent = ut ? ut.textContent : "The usual way";
      br.textContent = rt ? rt.textContent : "The Mud Theory way";
      function setTab(which){
        card.classList.toggle("show-usual", which === "usual");
        bu.classList.toggle("is-active", which === "usual");
        br.classList.toggle("is-active", which !== "usual");
        bu.setAttribute("aria-selected", which === "usual" ? "true" : "false");
        br.setAttribute("aria-selected", which === "usual" ? "false" : "true");
      }
      bu.addEventListener("click", function(){ setTab("usual"); });
      br.addEventListener("click", function(){ setTab("ritual"); });
      tabs.appendChild(bu); tabs.appendChild(br);
      cols.parentNode.insertBefore(tabs, cols);
      setTab("ritual");
    });
  }

  /* ---------- Step comparison: UGC videos. Play when visible (autoplay can be blocked in
     Low Power Mode / data saver; if play() is refused, hand the shopper the controls). ---------- */
  function initCompareVideos(){
    var vids = $$(".compare-card__media video");
    if(!vids.length) return;
    function tryPlay(v){
      var p; try{ p = v.play(); }catch(err){ v.controls = true; return; }
      if(p && p.catch){ p.catch(function(){ v.controls = true; }); }
    }
    if(!("IntersectionObserver" in window)){ vids.forEach(tryPlay); return; }
    var io = new IntersectionObserver(function(ents){
      ents.forEach(function(e){
        if(e.isIntersecting){ tryPlay(e.target); } else if(!e.target.paused){ e.target.pause(); }
      });
    }, { threshold:.35 });
    vids.forEach(function(v){ io.observe(v); });
  }

  /* ---------- Header scroll ---------- */
  function initHeader(){
    var h = $(".header"); if(!h) return;
    var on = function(){ h.classList.toggle("scrolled", window.scrollY > 12); };
    on(); window.addEventListener("scroll", on, { passive:true });
  }

  /* ---------- Mobile menu ---------- */
  function initMenu(){
    var menu = $("#MobileMenu");
    document.addEventListener("click", function(e){
      if(e.target.closest("[data-menu-open]")){ menu && menu.classList.add("show"); document.body.style.overflow="hidden"; }
      if(e.target.closest("[data-menu-close]") || e.target === menu){ menu && menu.classList.remove("show"); document.body.style.overflow=""; }
    });
  }

  /* ---------- Cart ---------- */
  var drawer = { el:null, scrim:null };
  var expressReq = 0;
  function openCart(){ if(T.cart_type==="page"){ window.location.href = T.routes.cart; return; } drawer.el && drawer.el.classList.add("show"); drawer.scrim && drawer.scrim.classList.add("show"); document.body.style.overflow="hidden"; }
  function closeCart(){ drawer.el && drawer.el.classList.remove("show"); drawer.scrim && drawer.scrim.classList.remove("show"); document.body.style.overflow=""; }

  function renderCart(cart){
    if(!cart || !Array.isArray(cart.items)){ return; }
    var count = cart.item_count;
    $$(".cart-count").forEach(function(c){ c.textContent = count; c.style.display = count>0 ? "" : "none"; });
    // cart progress bar: ritual steps (default) or free-shipping threshold
    var rbar = $("#ShipBar");
    if(rbar && count > 0) rbar.style.display = "";
    if(rbar && (rbar.getAttribute("data-bar-mode") || T.bar_mode || "ritual") === "ritual"){
      var rids = (rbar.getAttribute("data-ritual-ids") || "").split(",").filter(Boolean).map(function(x){ return parseInt(x,10); });
      var bundleId = parseInt(rbar.getAttribute("data-ritual-bundle"),10);
      var inIds = cart.items.map(function(i){ return i.product_id; });
      var total = rids.length || 4;
      var steps = rids.filter(function(id){ return inIds.indexOf(id) > -1; }).length;
      if(bundleId && inIds.indexOf(bundleId) > -1) steps = total;
      var done = total > 0 && steps >= total;
      var rtxt = $("#ShipBarTxt"), rfill = $("#ShipBarFill");
      var title = rbar.getAttribute("data-title") || "", body = (done ? rbar.getAttribute("data-done") : rbar.getAttribute("data-text")) || "";
      body = body.replace(/\[n\]/g, function(){ return String(steps); }).replace(/\[total\]/g, function(){ return String(total); });
      if(rtxt){ rtxt.innerHTML = (done ? '<span class="ship-bar__check" aria-hidden="true"></span>' : '') + '<b>' + escapeHtml(title) + '</b><span class="ship-bar__sub">' + escapeHtml(body) + '</span>'; }
      if(rfill){ rfill.style.width = (total ? Math.min(100, steps / total * 100) : 0) + "%"; }
      rbar.classList.toggle("is-unlocked", done);
      var gapR = $("#ShipGap"); if(gapR) gapR.style.display = "none";
    } else if(T.free_bar){
      var bar = $("#ShipBar");
      if(bar){
        var remain = Math.max(0, T.free_threshold - cart.total_price);
        var pct = T.free_threshold > 0 ? Math.min(100, (cart.total_price / T.free_threshold) * 100) : 100;
        var txt = $("#ShipBarTxt"), fill = $("#ShipBarFill");
        if(txt){ txt.innerHTML = remain > 0 ? ("You're <b>" + formatMoney(remain) + "</b> from free shipping") : '<span class="ship-bar__check" aria-hidden="true"></span><b>Free shipping unlocked</b>'; }
        if(fill){ fill.style.width = pct + "%"; }
        bar.classList.toggle("is-unlocked", remain <= 0);
        var gapEl = $("#ShipGap");
        if(gapEl){
          var gapId = parseInt(gapEl.getAttribute("data-upsell-product"),10);
          var inCart = cart.items.some(function(i){ return i.product_id === gapId; });
          gapEl.style.display = (remain > 0 && !inCart) ? "" : "none";
        }
      }
    }
    var body = $("#CartBody"); if(!body) return;
    if(count === 0){
      body.innerHTML = '<div class="cart-empty">'+icon("bag")+'<div><div class="serif" style="font-size:24px;margin-bottom:6px">Your ritual is empty</div><p style="font-size:14px;max-width:26ch;margin:0 auto">Four steps. Everything your skin needs, nothing it does not.</p></div><button class="btn btn--brown" data-cart-close>Start the ritual</button></div>';
      var foot = $("#CartFoot"); if(foot) foot.style.display="none";
      var exEmpty = $("#CartExpress"); if(exEmpty){ expressReq++; exEmpty.innerHTML = ""; exEmpty.removeAttribute("data-express-sig"); }
      var upgEmpty = $("#CartUpgrade"); if(upgEmpty){ upgEmpty.hidden = true; upgEmpty.removeAttribute("data-line-key"); }
      var barEmpty = $("#ShipBar"); if(barEmpty) barEmpty.style.display = "none";
      var uwEmpty = $("#CartUpsell");
      if(uwEmpty){ uwEmpty.style.display = ""; $$("[data-upsell-product]", uwEmpty).forEach(function(u){ u.style.display = ""; }); }
      return;
    }
    var foot = $("#CartFoot"); if(foot) foot.style.display="";
    if(T.cart_type !== "page") refreshExpress(cart);
    var lines = cart.items.map(function(it){
      var img = it.image ? '<img src="'+it.image.replace(/(\.[a-z]+)(\?|$)/, "_120x$1$2")+'" alt="'+escapeHtml(it.product_title)+'" loading="lazy">' : "";
      var meta = (it.options_with_values||[]).filter(function(o){ return o.value !== "Default Title"; }).map(function(o){ return o.value; }).join(" / ");
      var compare = (it.original_line_price > it.final_line_price) ? '<s>'+formatMoney(it.original_line_price)+'</s>' : "";
      return '<div class="cart-line" data-key="'+it.key+'">'+
        '<a class="cart-line__media" href="'+it.url+'">'+img+'</a>'+
        '<div style="flex:1;min-width:0">'+
          '<div class="cart-line__name">'+escapeHtml(it.product_title)+'</div>'+
          '<div class="cart-line__meta">'+escapeHtml(meta)+'</div>'+
          '<div class="cart-line__bottom">'+
            '<div class="qty"><button data-qty-down aria-label="Decrease">'+icon("minus")+'</button><span>'+it.quantity+'</span><button data-qty-up aria-label="Increase">'+icon("plus")+'</button></div>'+
            '<div class="price"><b>'+formatMoney(it.final_line_price)+'</b>'+compare+'</div>'+
          '</div>'+
          '<button class="cart-line__rm" data-remove>Remove</button>'+
        '</div></div>';
    }).join("");
    body.innerHTML = lines;
    var sub = $("#CartSubtotal"); if(sub) sub.textContent = formatMoney(cart.total_price);
    var checkout = $("#CartCheckout"); if(checkout) checkout.textContent = "Checkout · " + formatMoney(cart.total_price);
    // hide upsells already in cart; hide the whole block when nothing is left to offer
    var ids = cart.items.map(function(i){ return i.product_id; });
    var upsellWrap = $("#CartUpsell"), visible = 0;
    if(upsellWrap){
      $$("[data-upsell-product]", upsellWrap).forEach(function(u){
        var hide = ids.indexOf(parseInt(u.getAttribute("data-upsell-product"),10)) > -1;
        u.style.display = hide ? "none" : ""; if(!hide) visible++;
      });
      upsellWrap.style.display = visible > 0 ? "" : "none";
    }
    syncUpgrade(cart, upsellWrap);
  }

  /* ---------- Cart upgrade (Copy Guide 12): mask only -> Complete Ritual, Duo only -> Complete Ritual.
     Replaces the line (never leaves a second mask). Prices are live; [diff] is computed here. ---------- */
  function syncUpgrade(cart, upsellWrap){
    var box = $("#CartUpgrade"); if(!box) return;
    var maskId = parseInt(box.getAttribute("data-mask-id"),10), duoId = parseInt(box.getAttribute("data-duo-id"),10), ritualId = parseInt(box.getAttribute("data-ritual-id"),10);
    var ritualPrice = parseInt(box.getAttribute("data-ritual-price"),10) || 0;
    var mode = null;
    if(cart.items.length === 1 && cart.items[0].quantity === 1 && ritualId && cart.items[0].product_id !== ritualId){
      if(maskId && cart.items[0].product_id === maskId) mode = "mask";
      else if(duoId && cart.items[0].product_id === duoId) mode = "duo";
    }
    var feat = upsellWrap ? upsellWrap.querySelector(".upsell__item--feat") : null;
    if(!mode){ box.hidden = true; return; }
    var line = cart.items[0];
    var diff = ritualPrice - line.final_line_price;
    if(diff <= 0){ box.hidden = true; return; }
    var diffTxt = formatMoney(diff);
    var fill = function(sel, attr){ var el = box.querySelector(sel); if(!el) return; var raw = el.getAttribute("data-" + mode) || ""; el.textContent = raw.replace(/\[diff\]/g, function(){ return diffTxt; }); };
    fill("[data-upg-head]"); fill("[data-upg-text]"); fill("[data-upgrade-ritual]");
    var math = box.querySelector("[data-upg-math]");
    if(math){ math.innerHTML = '<span>' + escapeHtml(line.product_title) + ' ' + formatMoney(line.final_line_price) + '</span><span class="cart-upg__arrow" aria-hidden="true">&rarr;</span><span><b>' + escapeHtml(box.getAttribute("data-ritual-title") || "Complete Ritual") + ' ' + formatMoney(ritualPrice) + '</b></span>'; }
    box.setAttribute("data-line-key", line.key);
    box.hidden = false;
    if(feat) feat.style.display = "none";
  }
  function initUpgrade(){
    document.addEventListener("click", function(e){
      var btn = e.target.closest("[data-upgrade-ritual]"); if(!btn) return;
      var box = btn.closest("#CartUpgrade"); if(!box) return;
      var key = box.getAttribute("data-line-key"), vid = box.getAttribute("data-ritual-variant");
      if(!key || !vid) return;
      if(box.getAttribute("data-busy") === "1") return;
      box.setAttribute("data-busy", "1"); btn.disabled = true;
      btn.classList.add("is-loading"); drawer.el && drawer.el.classList.add("is-loading");
      // 1. remove the single line; only if the server confirms it is gone, 2. add the Complete Ritual
      fetch(T.routes.cart_change + ".js", { method:"POST", headers:{ "Content-Type":"application/json", "Accept":"application/json" }, body: JSON.stringify({ id:key, quantity:0 }) })
        .then(function(r){ if(!r.ok) throw new Error("change failed"); return r.json(); })
        .then(function(c){
          if(c && Array.isArray(c.items) && c.items.some(function(i){ return i.key === key; })) throw new Error("line still present");
          return fetch(T.routes.cart_add + ".js", { method:"POST", headers:{ "Content-Type":"application/json", "Accept":"application/json" }, body: JSON.stringify({ items:[{ id: parseInt(vid,10), quantity:1 }] }) });
        })
        .then(function(r){ return r.json(); })
        .then(function(){ return refreshCart(); })
        .catch(function(){ return refreshCart(); })
        .then(function(){ box.removeAttribute("data-busy"); btn.disabled = false; btn.classList.remove("is-loading"); drawer.el && drawer.el.classList.remove("is-loading"); });
    });
  }

  function fetchCart(){ return fetch(T.routes.cart + ".js", { headers:{ "Accept":"application/json" } }).then(function(r){ return r.json(); }); }
  function refreshCart(){ return fetchCart().then(renderCart); }

  /* ---------- Cart-level express checkout (real Apple Pay / Google Pay / Shop Pay / PayPal for the WHOLE cart, bundles included).
     Shopify renders these in sections/cart-express.liquid; we fetch that section through the Section Rendering API
     whenever the cart changes and mount it in the drawer footer. Skipped when the cart contents did not change. ---------- */
  var expressScriptSrcs = {};
  function runInjectedScripts(scope){
    // Scripts assigned via innerHTML never execute; recreate each one so the wallet
    // bootstrap actually runs. External srcs load once, inline bootstraps re-run per mount.
    Array.prototype.slice.call(scope.querySelectorAll("script")).forEach(function(old){
      var src = old.getAttribute("src");
      if(src){
        if(expressScriptSrcs[src]){ if(old.parentNode){ old.parentNode.removeChild(old); } return; }
        expressScriptSrcs[src] = 1;
      }
      var s = document.createElement("script");
      for(var i = 0; i < old.attributes.length; i++){ s.setAttribute(old.attributes[i].name, old.attributes[i].value); }
      s.text = old.text || "";
      old.parentNode.replaceChild(s, old);
    });
  }
  function refreshExpress(cart){
    var wrap = $("#CartExpress"); if(!wrap) return;
    var sig = cart.items.map(function(i){ return i.key + ":" + i.quantity + ":" + (i.selling_plan_allocation ? i.selling_plan_allocation.selling_plan.id : 0); }).join("|") + "|" + cart.currency;
    if(wrap.getAttribute("data-express-sig") === sig && wrap.firstChild) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    var mine = ++expressReq;
    fetch(root + "?sections=cart-express", { headers:{ "Accept":"application/json" } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){
        if(mine !== expressReq || !j || typeof j["cart-express"] !== "string") return;
        var tmp = document.createElement("div"); tmp.innerHTML = j["cart-express"];
        var inner = tmp.querySelector("[data-cart-express]");
        wrap.innerHTML = inner ? inner.outerHTML : "";
        wrap.setAttribute("data-express-sig", sig);
        runInjectedScripts(wrap);
        try{ if(window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init){ Shopify.PaymentButton.init(); } }catch(err){}
      })
      .catch(function(){ /* wallets are a bonus; the Checkout button always works */ });
  }

  function addToCart(id, qty, sellingPlan){
    var item = { id:id, quantity: qty||1 };
    if(sellingPlan){ item.selling_plan = sellingPlan; }
    return fetch(T.routes.cart_add + ".js", {
      method:"POST", headers:{ "Content-Type":"application/json", "Accept":"application/json" },
      body: JSON.stringify({ items:[item] })
    }).then(function(r){ return r.json(); }).then(function(){ return refreshCart(); });
  }
  function changeLine(key, qty){
    return fetch(T.routes.cart_change + ".js", {
      method:"POST", headers:{ "Content-Type":"application/json", "Accept":"application/json" },
      body: JSON.stringify({ id:key, quantity:qty })
    }).then(function(r){ return r.json(); }).then(function(c){ return (c && Array.isArray(c.items)) ? renderCart(c) : refreshCart(); })
      .catch(function(){ return refreshCart().catch(function(){ $$(".cart-line.is-updating").forEach(function(l){ l.classList.remove("is-updating"); }); }); });
  }

  function initCart(){
    drawer.el = $("#CartDrawer"); drawer.scrim = $("#CartScrim");
    document.addEventListener("click", function(e){
      var openBtn = e.target.closest("[data-cart-open]");
      if(openBtn){ e.preventDefault(); openCart(); return; }
      if(e.target.closest("[data-cart-close]") || e.target === drawer.scrim){ closeCart(); return; }
      var add = e.target.closest("[data-add-variant]");
      if(add){
        e.preventDefault();
        var vid = add.getAttribute("data-add-variant");
        add.classList.add("is-loading");
        if(T.cart_type !== "page") openCart();
        drawer.el && drawer.el.classList.add("is-loading");
        addToCart(vid, 1).then(function(){ if(T.cart_type === "page") openCart(); }).finally(function(){
          add.classList.remove("is-loading");
          drawer.el && drawer.el.classList.remove("is-loading");
        });
        return;
      }
      var line = e.target.closest(".cart-line");
      if(line){
        var key = line.getAttribute("data-key");
        var span = line.querySelector(".qty span");
        var q = parseInt(span ? span.textContent : "1", 10);
        var acted = false;
        if(e.target.closest("[data-qty-up]")){ acted = true; changeLine(key, q+1); }
        else if(e.target.closest("[data-qty-down]")){ acted = true; changeLine(key, q-1); }
        else if(e.target.closest("[data-remove]")){ acted = true; changeLine(key, 0); }
        if(acted){ line.classList.add("is-updating"); }
      }
    });
    document.addEventListener("keydown", function(e){ if(e.key === "Escape"){ closeCart(); } });
    refreshCart();
  }

  /* ---------- Product forms (PDP + hero): submit the WHOLE form so
     bundle/subscription app fields are included, like standard themes ---------- */
  function addFormToCart(form){
    var fd = new FormData(form);
    var planInput = form.querySelector("[data-selling-plan-input]");
    if(planInput && !planInput.value){ fd.delete("selling_plan"); }
    return fetch(T.routes.cart_add + ".js", {
      method: "POST",
      headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: fd
    }).then(function(r){ return r.json(); }).then(function(){ return refreshCart(); });
  }
  /* ---------- Buy now: add the current form (bundle/plan fields included), then checkout ---------- */
  function expressVisible(wrap){
    var ex = wrap.querySelector("[data-express]"); if(!ex) return false;
    var btn = ex.querySelector(".shopify-payment-button__button, .shopify-payment-button button, .shopify-payment-button");
    if(!btn) return false;
    var cs = getComputedStyle(btn); if(cs.display === "none" || cs.visibility === "hidden") return false;
    var r = btn.getBoundingClientRect(); return r.height > 8;
  }
  function syncBuyNow(){
    $$("[data-buy-now-wrap]").forEach(function(wrap){
      var theme = wrap.querySelector("[data-buy-now]"), note = wrap.querySelector(".buy-stack__secure");
      if(!theme) return;
      var showTheme = !expressVisible(wrap);
      theme.style.display = showTheme ? "" : "none";
      if(note) note.style.display = showTheme ? "" : "none";
    });
  }
  function initBuyNow(){
    // keep theme Buy now and Shopify express mutually exclusive, re-checking as apps show/hide the express button
    if(!window.__mtBuyNowSync){
      window.__mtBuyNowSync = true;
      var t; var kick = function(){ clearTimeout(t); t = setTimeout(syncBuyNow, 60); };
      kick(); setTimeout(syncBuyNow, 600); setTimeout(syncBuyNow, 1500); setTimeout(syncBuyNow, 3000);
      if("MutationObserver" in window){
        $$("[data-buy-now-wrap]").forEach(function(w){ new MutationObserver(kick).observe(w, { childList:true, subtree:true, attributes:true, attributeFilter:["style","class","hidden"] }); });
      }
      document.addEventListener("change", kick, true);
      document.addEventListener("click", kick, true);
      window.addEventListener("resize", kick);
    }
    $$("[data-buy-now]").forEach(function(btn){
      if(btn.dataset.bound) return; btn.dataset.bound = "1";
      btn.addEventListener("click", function(e){
        e.preventDefault();
        var form = btn.closest("form"); if(!form) return;
        var idInput = form.querySelector("[name=id]");
        if(idInput && !idInput.value) return;
        btn.classList.add("is-loading");
        var fd = new FormData(form);
        var planInput = form.querySelector("[data-selling-plan-input]");
        if(planInput && !planInput.value){ fd.delete("selling_plan"); }
        fetch(T.routes.cart_add + ".js", { method:"POST", headers:{ "Accept":"application/json", "X-Requested-With":"XMLHttpRequest" }, body: fd })
          .then(function(r){ return r.json(); })
          .then(function(res){
            if(res && res.status && res.status >= 400){ throw new Error(res.description || "Could not add"); }
            window.location.href = "/checkout";
          })
          .catch(function(){ btn.classList.remove("is-loading"); openCart(); refreshCart(); });
      });
    });
  }

  function initProductForm(){
    $$("#ProductForm, form.js-ajax-form").forEach(function(form){
      if(form.dataset.submitBound) return;
      form.dataset.submitBound = "1";
      form.addEventListener("submit", function(e){
        e.preventDefault();
        var btn = form.querySelector("[type=submit]");
        var idInput = form.querySelector("[name=id]");
        if(idInput && !idInput.value) return;
        btn && btn.classList.add("is-loading");
        if(T.cart_type !== "page") openCart();
        drawer.el && drawer.el.classList.add("is-loading");
        addFormToCart(form).then(function(){ if(T.cart_type === "page") openCart(); }).finally(function(){
          btn && btn.classList.remove("is-loading");
          drawer.el && drawer.el.classList.remove("is-loading");
        });
      });
    });
  }

  /* ---------- Product buy box (variants + bundle offers + subscribe) ---------- */
  function initProductBuy(){
    $$("[data-product-root]").forEach(function(root){
      var form = $("#ProductForm", root);
      if(!form || form.dataset.bound) return; form.dataset.bound = "1";
      var data; try{ data = JSON.parse($("[data-variant-json]", root).textContent); }catch(err){ data = { variants:[] }; }
      var idInput = $("[name=id]", form);
      var planInput = $("[data-selling-plan-input]", form);
      var picker = $("[data-variant-picker]", root);
      var subs = $("[data-subs]", root);
      var submit = $("[type=submit]", form);
      var addLabel = (submit && submit.getAttribute("data-add-label")) || "Add to cart";

      var state = {
        offer: "single",
        bundleVariant: null, bundlePrice: 0, bundleCompare: 0,
        singleVariant: (idInput && idInput.value) || (data.variants[0] && data.variants[0].id),
        plan: ""
      };

      function single(){ return data.variants.find(function(v){ return String(v.id) === String(state.singleVariant); }) || data.variants[0] || {}; }

      function apply(){
        var price, compare, available = true, variantId;
        if(state.offer === "bundle"){
          variantId = state.bundleVariant; price = state.bundlePrice; compare = state.bundleCompare;
        } else {
          var v = single(); variantId = v.id; compare = v.compare_at_price; available = v.available !== false;
          if(state.plan){
            var pEl = $('[name=mt-plan][data-plan="' + state.plan + '"]', root);
            price = pEl ? parseInt(pEl.getAttribute("data-price"), 10) : v.price;
          } else { price = v.price; }
        }
        if(idInput && variantId != null) idInput.value = variantId;
        if(planInput) planInput.value = (state.offer === "single") ? state.plan : "";
        $$("[data-price-now]", root).forEach(function(n){ n.textContent = formatMoney(price); });
        var wasEl = $("[data-price-was]", root);
        if(wasEl){ if(compare && compare > price){ wasEl.textContent = formatMoney(compare); wasEl.style.display=""; } else { wasEl.style.display="none"; } }
        $$("[data-atc-price]", root).forEach(function(n){ n.textContent = formatMoney(price); });
        if(submit){
          var lbl = submit.querySelector("[data-atc-label]");
          if(available){ submit.removeAttribute("disabled"); if(lbl) lbl.textContent = addLabel; }
          else { submit.setAttribute("disabled","true"); if(lbl) lbl.textContent = "Sold out"; }
        }
        if(picker) picker.style.display = (state.offer === "bundle") ? "none" : "";
        if(subs) subs.style.display = (state.offer === "bundle") ? "none" : "";
      }

      if(picker){
        picker.addEventListener("click", function(e){
          var opt = e.target.closest(".variant-opt"); if(!opt) return;
          var group = opt.closest("[data-option-index]");
          $$(".variant-opt", group).forEach(function(o){ o.classList.remove("active"); });
          opt.classList.add("active");
          var vals = $$(".variant-opt.active", picker).map(function(o){ return o.getAttribute("data-value"); });
          var v = data.variants.find(function(vv){ return vv.options.join("~~~") === vals.join("~~~"); });
          if(v){
            state.singleVariant = v.id;
            var so = $('[name=mt-offer][data-offer-type="single"]', root);
            if(so){ so.setAttribute("data-variant", v.id); so.setAttribute("data-price", v.price); }
          }
          apply();
        });
      }

      $$('[name=mt-offer]', root).forEach(function(r){
        r.addEventListener("change", function(){
          state.offer = r.getAttribute("data-offer-type");
          if(state.offer === "bundle"){
            state.bundleVariant = r.getAttribute("data-variant");
            state.bundlePrice = parseInt(r.getAttribute("data-price"), 10);
            state.bundleCompare = parseInt(r.getAttribute("data-compare"), 10) || 0;
          }
          $$(".pdp-offer", root).forEach(function(l){ l.classList.remove("is-active"); });
          var lab = r.closest(".pdp-offer"); if(lab) lab.classList.add("is-active");
          apply();
        });
      });

      $$('[name=mt-plan]', root).forEach(function(r){
        r.addEventListener("change", function(){
          state.plan = r.getAttribute("data-plan") || "";
          $$(".pdp-sub", root).forEach(function(l){ l.classList.remove("is-active"); });
          var lab = r.closest(".pdp-sub"); if(lab) lab.classList.add("is-active");
          apply();
        });
      });

      apply();
    });
  }

  /* ---------- Lightbox (tap to expand media) ---------- */
  var lightboxEl = null;
  function openLightbox(slides, start, onNav){
    if(!slides.length) return;
    if(!lightboxEl){
      lightboxEl = document.createElement("div");
      lightboxEl.className = "lightbox";
      lightboxEl.innerHTML = '<button class="lightbox__close" type="button" aria-label="Close">' + icon("close") + '</button>' +
        '<button class="lightbox__nav lightbox__nav--prev" type="button" aria-label="Previous">' + icon("arrow") + '</button>' +
        '<div class="lightbox__stage"></div>' +
        '<button class="lightbox__nav lightbox__nav--next" type="button" aria-label="Next">' + icon("arrow") + '</button>' +
        '<div class="lightbox__count"></div>';
      document.body.appendChild(lightboxEl);
      lightboxEl.addEventListener("click", function(e){
        if(e.target.closest(".lightbox__close")){ lightboxEl._close(); return; }
        if(e.target.closest(".lightbox__nav--prev")){ lightboxEl._nav(-1); return; }
        if(e.target.closest(".lightbox__nav--next")){ lightboxEl._nav(1); return; }
        if(e.target === lightboxEl){ lightboxEl._close(); }
      });
      var tx = 0, ty = 0;
      lightboxEl.addEventListener("touchstart", function(e){ if(e.touches[0]){ tx = e.touches[0].clientX; ty = e.touches[0].clientY; } }, { passive:true });
      lightboxEl.addEventListener("touchend", function(e){
        var t = e.changedTouches[0]; if(!t) return;
        var dx = t.clientX - tx, dy = t.clientY - ty;
        if(Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.4){ lightboxEl._nav(dx < 0 ? 1 : -1); }
      }, { passive:true });
    }
    var stage = $(".lightbox__stage", lightboxEl);
    var count = $(".lightbox__count", lightboxEl);
    var cur = start;
    function render(){
      stage.innerHTML = slides[cur].innerHTML;
      $$("img", stage).forEach(function(im){ im.removeAttribute("sizes"); im.removeAttribute("loading"); });
      count.textContent = (cur + 1) + " / " + slides.length;
      if(onNav) onNav(cur);
    }
    function nav(d){ cur = (cur + d + slides.length) % slides.length; render(); }
    function onKey(e){
      if(e.key === "Escape") close();
      if(e.key === "ArrowRight") nav(1);
      if(e.key === "ArrowLeft") nav(-1);
    }
    function close(){
      lightboxEl.classList.remove("show");
      stage.innerHTML = "";
      document.body.style.overflow = "";
      document.removeEventListener("keydown", onKey);
    }
    lightboxEl._nav = nav;
    lightboxEl._close = close;
    document.addEventListener("keydown", onKey);
    lightboxEl.classList.add("show");
    document.body.style.overflow = "hidden";
    render();
  }

  /* ---------- PDP gallery (media slides: images + video) ---------- */
  function initGallery(){
    $$("[data-gallery]").forEach(function(g){
      if(g.dataset.bound) return; g.dataset.bound = "1";
      var main = $(".pdp-gallery__main", g);
      if(!main) return;
      var slides = $$(".pdp-slide", main);
      var thumbs = $$(".pdp-thumb", g);
      if(!slides.length) return;
      var i = 0;
      function show(n){
        i = (n + slides.length) % slides.length;
        slides.forEach(function(s, k){
          s.classList.toggle("active", k === i);
          if(k !== i){ $$("video", s).forEach(function(v){ v.pause(); }); }
        });
        thumbs.forEach(function(t, k){ t.classList.toggle("active", k === i); });
      }
      thumbs.forEach(function(t, k){ t.addEventListener("click", function(){ show(k); }); });
      var prev = $(".pdp-gallery__nav--prev", g), next = $(".pdp-gallery__nav--next", g);
      prev && prev.addEventListener("click", function(e){ e.stopPropagation(); show(i - 1); });
      next && next.addEventListener("click", function(e){ e.stopPropagation(); show(i + 1); });
      // swipe between media on touch
      var sx = 0, sy = 0;
      main.addEventListener("touchstart", function(e){ if(e.touches[0]){ sx = e.touches[0].clientX; sy = e.touches[0].clientY; } }, { passive:true });
      main.addEventListener("touchend", function(e){
        var t = e.changedTouches[0]; if(!t) return;
        var dx = t.clientX - sx, dy = t.clientY - sy;
        if(Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.4){ if(dx < 0){ show(i + 1); } else { show(i - 1); } }
      }, { passive:true });
      // tap to expand (skip video controls and nav arrows)
      main.addEventListener("click", function(e){
        if(e.target.closest(".pdp-gallery__nav")) return;
        if(e.target.closest("video, iframe")) return;
        openLightbox(slides, i, function(n){ show(n); });
      });
      show(0);
    });
  }

  /* ---------- Before/After ---------- */
  function initBeforeAfter(){
    $$(".ba").forEach(function(ba){
      var before = $(".ba__before", ba), handle = $(".ba__handle", ba);
      var dragging = false;
      function set(clientX){
        var r = ba.getBoundingClientRect();
        var p = Math.max(0, Math.min(100, ((clientX - r.left)/r.width)*100));
        before.style.clipPath = "inset(0 " + (100-p) + "% 0 0)";
        handle.style.left = p + "%";
      }
      ba.addEventListener("mousedown", function(e){ dragging=true; set(e.clientX); });
      ba.addEventListener("touchstart", function(e){ dragging=true; if(e.touches[0]) set(e.touches[0].clientX); }, {passive:true});
      window.addEventListener("mousemove", function(e){ if(dragging) set(e.clientX); });
      window.addEventListener("touchmove", function(e){ if(dragging && e.touches[0]) set(e.touches[0].clientX); }, {passive:true});
      window.addEventListener("mouseup", function(){ dragging=false; });
      window.addEventListener("touchend", function(){ dragging=false; });
      ba.addEventListener("keydown", function(e){
        var cur = parseFloat(handle.style.left) || 50;
        if(e.key==="ArrowLeft"){ var r=ba.getBoundingClientRect(); set(r.left + r.width*(cur-4)/100); e.preventDefault(); }
        if(e.key==="ArrowRight"){ var r2=ba.getBoundingClientRect(); set(r2.left + r2.width*(cur+4)/100); e.preventDefault(); }
      });
    });
  }

  /* ---------- Mobile swipe scrollers with dots ---------- */
  function initMobileScrollers(){
    $$(".results-grid, .ritual-steps, .treats-grid, #theory .g3, #ritual .prod-grid, .atlas-grid, .offer-grid, .compare-grid, .heritage-line").forEach(function(grid){
      if(grid.dataset.carousel) return; grid.dataset.carousel = "1";
      var cards = Array.prototype.slice.call(grid.children).filter(function(c){ return c.nodeType === 1; });
      if(cards.length < 2) return;
      var dots = document.createElement("div"); dots.className = "results-dots";
      cards.forEach(function(_, i){
        var d = document.createElement("button"); d.type = "button"; d.className = "results-dot";
        d.setAttribute("aria-label", "Go to item " + (i + 1));
        d.addEventListener("click", function(){ cards[i].scrollIntoView({ behavior:"smooth", inline:"center", block:"nearest" }); });
        dots.appendChild(d);
      });
      grid.parentNode.insertBefore(dots, grid.nextSibling);
      function update(){
        if(grid.scrollWidth <= grid.clientWidth + 4){ dots.style.display = "none"; return; }
        dots.style.display = "flex";
        var box = grid.getBoundingClientRect(), center = box.left + box.width / 2, best = 0, bd = 1e9;
        cards.forEach(function(c, i){ var r = c.getBoundingClientRect(), cc = r.left + r.width / 2, dd = Math.abs(cc - center); if(dd < bd){ bd = dd; best = i; } });
        $$(".results-dot", dots).forEach(function(d, i){ d.classList.toggle("active", i === best); });
      }
      grid.addEventListener("scroll", update, { passive:true });
      window.addEventListener("resize", update);
      update();

      // mouse / pen drag-to-scroll (touch already scrolls natively)
      var isDown = false, moved = false, startX = 0, startLeft = 0;
      function release(e){
        if(!isDown) return;
        isDown = false;
        grid.classList.remove("is-dragging");
        try{ grid.releasePointerCapture(e.pointerId); }catch(err){}
      }
      grid.addEventListener("pointerdown", function(e){
        if(e.pointerType === "touch") return;
        if(grid.scrollWidth <= grid.clientWidth + 4) return;
        isDown = true; moved = false; startX = e.clientX; startLeft = grid.scrollLeft;
        grid.classList.add("is-dragging");
        try{ grid.setPointerCapture(e.pointerId); }catch(err){}
      });
      grid.addEventListener("pointermove", function(e){
        if(!isDown) return;
        var dx = e.clientX - startX;
        if(Math.abs(dx) > 6) moved = true;
        grid.scrollLeft = startLeft - dx;
      });
      grid.addEventListener("pointerup", release);
      grid.addEventListener("pointercancel", release);
      grid.addEventListener("click", function(e){
        if(moved){ e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
    });
  }

  /* ---------- Region / currency picker ---------- */
  function initRegion(){
    $$("[data-region-select]").forEach(function(sel){
      if(sel.dataset.bound) return; sel.dataset.bound = "1";
      sel.addEventListener("change", function(){ var f = sel.closest("form"); if(f){ f.submit(); } });
    });
  }

  /* ---------- Sticky ATC ---------- */
  function initStickyAtc(){
    var bar = $("#StickyAtc"); var watch = $("#ProductBuyBox");
    if(!bar || !watch) return;
    var on = function(){ var r = watch.getBoundingClientRect(); bar.classList.toggle("show", r.bottom < 60); };
    on(); window.addEventListener("scroll", on, { passive:true });
    var btn = $("[data-sticky-add]", bar);
    if(btn && !btn.dataset.bound){
      btn.dataset.bound = "1";
      btn.addEventListener("click", function(){
        var f = $("#ProductForm");
        if(!f) return;
        if(f.requestSubmit){ f.requestSubmit(); }
        else { f.dispatchEvent(new Event("submit", { cancelable:true, bubbles:true })); }
      });
    }
  }

  /* ---------- Hero media: thumbs + arrows + swipe + keys ---------- */
  function initHeroThumbs(){
    $$(".hero__media").forEach(function(mediaWrap){
      if(mediaWrap.dataset.bound) return;
      var main = mediaWrap.querySelector("[data-hero-slides]"); if(!main) return;
      var slides = $$(".pdp-slide", main); if(!slides.length) return;
      mediaWrap.dataset.bound = "1";
      var wrap = mediaWrap.querySelector("[data-hero-thumbs]");
      var thumbs = wrap ? $$(".hero__thumb", wrap) : [];
      var i = Math.max(0, slides.findIndex(function(s){ return s.classList.contains("active"); }));
      function show(n){
        i = (n + slides.length) % slides.length;
        slides.forEach(function(s,k){ s.classList.toggle("active", k===i); if(k!==i){ $$("video", s).forEach(function(v){ v.pause(); }); } });
        thumbs.forEach(function(t,k){ t.classList.toggle("active", k===i); });
        if(thumbs[i] && thumbs[i].scrollIntoView){ thumbs[i].scrollIntoView({ behavior:"smooth", inline:"center", block:"nearest" }); }
        mediaWrap.classList.toggle("is-browsing", i > 0);
      }
      if(wrap){ wrap.addEventListener("click", function(e){ var b=e.target.closest(".hero__thumb"); if(!b) return; var k=thumbs.indexOf(b); if(k>-1) show(k); }); }
      var prev = mediaWrap.querySelector("[data-hero-prev]"), next = mediaWrap.querySelector("[data-hero-next]");
      prev && prev.addEventListener("click", function(e){ e.preventDefault(); e.stopPropagation(); show(i-1); });
      next && next.addEventListener("click", function(e){ e.preventDefault(); e.stopPropagation(); show(i+1); });
      // swipe
      var sx=0, sy=0;
      main.addEventListener("touchstart", function(e){ if(e.touches[0]){ sx=e.touches[0].clientX; sy=e.touches[0].clientY; } }, { passive:true });
      main.addEventListener("touchend", function(e){ var t=e.changedTouches[0]; if(!t) return; var dx=t.clientX-sx, dy=t.clientY-sy; if(Math.abs(dx)>44 && Math.abs(dx)>Math.abs(dy)*1.4){ show(dx<0 ? i+1 : i-1); } }, { passive:true });
      // keyboard when the media is focused
      main.setAttribute("tabindex","0");
      main.addEventListener("keydown", function(e){ if(e.key==="ArrowRight"){ show(i+1); } if(e.key==="ArrowLeft"){ show(i-1); } });
    });
  }




  /* ---------- Reviews load more ---------- */
  function initReviews(){
    $$("[data-reviews-more]").forEach(function(btn){
      if(btn.dataset.bound) return; btn.dataset.bound = "1";
      btn.addEventListener("click", function(){
        var wall = document.querySelector("[data-reviews-wall]");
        if(!wall) return;
        $$(".review-card.is-hidden", wall).slice(0, 6).forEach(function(c){ c.classList.remove("is-hidden"); });
        if($$(".review-card.is-hidden", wall).length === 0){ btn.style.display = "none"; }
      });
    });
  }

  /* ---------- Count up ---------- */
  function initCountUp(){
    // The real value is already in the HTML. Only animate when we can, from 0 up to it,
    // and never leave the element blank or at 0 if anything goes wrong.
    if(!("IntersectionObserver" in window) || !("requestAnimationFrame" in window)) return;
    if(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var io = new IntersectionObserver(function(ents){
      ents.forEach(function(e){
        if(!e.isIntersecting) return; io.unobserve(e.target);
        var el = e.target, to = parseFloat(el.getAttribute("data-count")), suf = el.getAttribute("data-suffix")||"";
        var finalText = el.textContent;
        if(isNaN(to)) return;
        var start = performance.now(), dur = 1400;
        function tick(now){
          var p = Math.min(1,(now-start)/dur), eased = 1-Math.pow(1-p,3);
          el.textContent = Math.round(to*eased).toLocaleString() + suf;
          if(p<1) requestAnimationFrame(tick); else el.textContent = finalText;
        }
        requestAnimationFrame(tick);
      });
    }, { threshold:.4 });
    $$("[data-count]").forEach(function(el){ io.observe(el); });
  }


  /* ---------- helpers ---------- */
  function escapeHtml(s){ return (s||"").replace(/[&<>"']/g, function(c){ return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;","'":"&#39;"}[c]; }); }
  function icon(name){
    var I = {
      bag:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 8h12l1 12H5L6 8Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>',
      plus:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M12 5v14M5 12h14"/></svg>',
      minus:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M5 12h14"/></svg>',
      close:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M6 6l12 12M18 6 6 18"/></svg>',
      arrow:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M5 12h14M13 6l6 6-6 6"/></svg>'
    };
    return I[name]||"";
  }

  /* ---------- init ---------- */
  function init(){
    initReveal(); initHeader(); initMenu(); initCart(); initProductForm();
    initProductBuy(); initGallery(); initBeforeAfter(); initMobileScrollers(); initStickyAtc(); initCountUp(); initReviews(); initHeroThumbs(); initRegion(); initCompareTabs(); initCompareVideos(); initBuyNow(); initUpgrade();
    // re-run reveal after Shopify section reloads in editor
    document.addEventListener("shopify:section:load", function(){ initReveal(); initBeforeAfter(); initMobileScrollers(); initGallery(); initProductForm(); initProductBuy(); initStickyAtc(); initCountUp(); initReviews(); initHeroThumbs(); initRegion(); initCompareTabs(); initCompareVideos(); initBuyNow(); });
  }
  if(document.readyState === "loading"){ document.addEventListener("DOMContentLoaded", init); } else { init(); }
})();
